// extracted by mini-css-extract-plugin
module.exports = {"primary":"button__primary--1uQvu","raised":"button__raised--19nfQ","floating":"button__floating--fk7Go","flat":"button__flat--3iVVz","toggle":"button__toggle--3H-v5"};